import * as _4 from 'lodash4';
import { IStrategySafe, StrategySafe } from 'utility-ts-strategy';
import { PathTask } from './../builders/path_task_builder';
import { MustDoToDoQuery } from './../queries/mandatory_to_do_query';
import { OverdueToDoQuery } from './../queries/overdue_to_do_query';
import { IToDo } from './to_do_builder_servant';
import { IStaffDrivenToDo, StaffTodoFilterServant } from 'data-ng-staff-todos';

export class TodoFilterServant {
  private strategy: IStrategySafe<any, string>;

  constructor(
    private ngMustDoToDoQuery: MustDoToDoQuery,
    private ngOverdueToDoQuery: OverdueToDoQuery,
    private TaskStatusEnum: any,
    private EventCategoryEnum: any,
    private ngStaffTodoFilterServant: StaffTodoFilterServant
  ) {
    this.strategy = new StrategySafe<any, string>({
      allToDo: this.getAllToDo,
      activeToDosAndEvents: this.activeToDosAndEvents,
      activeTodosAndEventsForToday: this.activeTodosAndEventsForToday,
      todosForToday: this.todosForToday,
      eventsForToday: this.eventsForToday,
      completedTodos: this.completedTodos,
      overdueTodos: this.overdueTodos,
      hiddenTodos: this.hiddenTodos,
      staffTodos: this.staffTodos
    });
  }

  get filterStrategy(): IStrategySafe<any, string> {
    return this.strategy;
  }

  getAllToDo(): Array<IToDo | IStaffDrivenToDo> {
    return TodoFilterServant._sortTodosByDate(this.ngMustDoToDoQuery.result);
  }

  activeToDosAndEvents(): Array<IToDo | IStaffDrivenToDo> {
    const todos = _4.filter(this.ngMustDoToDoQuery.result, ({ task }) => this.TaskStatusEnum.isActive(task.status));
    const staffTodos: Array<IToDo | IStaffDrivenToDo> = this.ngStaffTodoFilterServant.upcomingStaffTodos();
    const unSorted = _4.union(todos, staffTodos);
    return TodoFilterServant._sortTodosByDate(unSorted);
  }

  activeTodosAndEventsForToday(): Array<IToDo | IStaffDrivenToDo> {
    const endofDay: moment.Moment = moment().endOf('day');
    const todos: Array<IToDo | IStaffDrivenToDo> = _4.filter(
      this.ngMustDoToDoQuery.result,
      ({ task }) =>
        this.TaskStatusEnum.isActive(task.status) &&
        (task.start_ts.isBefore(endofDay) || task.end_ts.isBefore(endofDay))
    );
    const staffTodos: Array<IToDo | IStaffDrivenToDo> = this.ngStaffTodoFilterServant.staffTodosForToday();
    const unSorted = _4.union(todos, staffTodos);
    return TodoFilterServant._sortTodosByDate(unSorted);
  }

  todosForToday(): Array<IToDo | IStaffDrivenToDo> {
    const endofDay: moment.Moment = moment().endOf('day');
    const todos: Array<IToDo | IStaffDrivenToDo> = _4.filter(
      this.ngMustDoToDoQuery.result,
      ({ task }) =>
        this.TaskStatusEnum.isActive(task.status) &&
        (task.start_ts.isBefore(endofDay) || task.end_ts.isBefore(endofDay)) &&
        !this.EventCategoryEnum.isDateMarker(task.category)
    );
    const staffTodos: Array<IToDo | IStaffDrivenToDo> = this.ngStaffTodoFilterServant.staffTodosForToday();
    const unSorted = _4.union(todos, staffTodos);
    return TodoFilterServant._sortTodosByDate(unSorted);
  }

  eventsForToday(): Array<IToDo | IStaffDrivenToDo> {
    const endofDay: moment.Moment = moment().endOf('day');
    const unSorted = _4.filter(
      this.ngMustDoToDoQuery.result,
      ({ task }: { task: PathTask }) =>
        this.TaskStatusEnum.isActive(task.status) &&
        (task.start_ts.isBefore(endofDay) || task.end_ts.isBefore(endofDay)) &&
        this.EventCategoryEnum.isDateMarker(task.category)
    );
    return TodoFilterServant._sortTodosByDate(unSorted);
  }

  completedTodos(): Array<IToDo | IStaffDrivenToDo> {
    const todos: Array<IToDo | IStaffDrivenToDo> = _4.filter(
      this.ngMustDoToDoQuery.result,
      ({ task }: { task: PathTask }) => this.TaskStatusEnum.isCompleted(task.status)
    );
    const staffTodos: Array<IToDo | IStaffDrivenToDo> = this.ngStaffTodoFilterServant.completedStaffTodos();
    const unSorted = _4.union(todos, staffTodos);
    return TodoFilterServant._sortTodosByDate(unSorted);
  }

  overdueTodos(): Array<IToDo | IStaffDrivenToDo> {
    const todos: Array<IToDo | IStaffDrivenToDo> = this.ngOverdueToDoQuery.result;
    const staffTodos: Array<IToDo | IStaffDrivenToDo> = this.ngStaffTodoFilterServant.overdueStaffTodos();
    const unSorted = _4.union(todos, staffTodos);
    return TodoFilterServant._sortTodosByDate(unSorted);
  }

  hiddenTodos(): Array<IToDo | IStaffDrivenToDo> {
    const unSorted = _4.filter(this.ngMustDoToDoQuery.result, ({ task }: { task: PathTask }) =>
      this.TaskStatusEnum.isDismissed(task.status)
    );
    return TodoFilterServant._sortTodosByDate(unSorted);
  }

  staffTodos(): Array<IToDo | IStaffDrivenToDo> {
    const todayStaffTodos: Array<IToDo | IStaffDrivenToDo> = this.ngStaffTodoFilterServant.staffTodosForToday();
    const upcomingStaffTodos: Array<IToDo | IStaffDrivenToDo> = this.ngStaffTodoFilterServant.upcomingStaffTodos();
    const unSorted = _4.union(todayStaffTodos, upcomingStaffTodos);
    return TodoFilterServant._sortTodosByDate(unSorted);
  }

  private static _sortTodosByDate(unsortedTodos: Array<IToDo | IStaffDrivenToDo>): Array<IToDo | IStaffDrivenToDo> {
    return _4.sortBy(
      unsortedTodos,
      ({ task }) => {
        return (task as any).end_ts || (task as any).due_date;
      },
      ({ task }) => {
        return (task as any).start_ts || (task as any).created_on;
      }
    );
  }
}

angular.module('data-ng-todos').service('ngTodoFilterServant', TodoFilterServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/servants/to_do_filter_servant.ts